<template>
  <div class="detection-entrust">
    <section class="hero">
      <div class="hero-inner">
        <h2>检测任务委托</h2>
        <div class="subtitle">在线提交水泵检测委托单，支付后送样检测，报告在线下载</div>
      </div>
    </section>

    <div class="main-wrap">
      <div class="card">
        <div class="card-head">
          <div class="head-title">
            <span class="bar"></span>
            <span>检测业务办理<span class="en">DETECTION SERVICE</span></span>
          </div>
          <div class="tabs">
            <div class="tab" :class="{ active: activeTab === 'apply' }" @click="activeTab = 'apply'">在线委托</div>
            <div class="tab" :class="{ active: activeTab === 'list' }" @click="switchTab('list')">我的委托单</div>
            <div class="tab" :class="{ active: activeTab === 'fee' }" @click="switchTab('fee')">收费标准</div>
          </div>
        </div>

        <!-- 在线委托：一单一条检测任务 -->
        <div v-show="activeTab === 'apply'" class="tab-panel">
          <div class="section-title"><span class="bar"></span>单位信息<span class="tip">企业账号自动带入当前企业信息；个人账号请从已认证企业中选择</span></div>
          <el-form :model="form" label-width="120px">
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item label="委托单位" required>
                  <el-select
                    v-model="form.enterpriseUuid"
                    filterable
                    clearable
                    placeholder="请选择委托单位"
                    style="width:100%"
                    @change="onEntrustUnitChange"
                  >
                    <el-option
                      v-for="e in enterpriseList"
                      :key="e.uuid"
                      :label="e.name"
                      :value="e.uuid"
                    ></el-option>
                  </el-select>
                  <div class="auth-hint">还不是企业用户？<a href="javascript:;" @click="goEnterpriseAuth">去企业认证</a></div>
                </el-form-item>
              </el-col>
              <el-col :span="12"><el-form-item label="单位地址"><el-input v-model="form.unitAddress" placeholder="请输入单位地址"></el-input></el-form-item></el-col>
              <el-col :span="12"><el-form-item label="委托日期" required><el-date-picker v-model="form.entrustDate" type="date" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker></el-form-item></el-col>
              <el-col :span="12"><el-form-item label="联系人" required><el-input v-model="form.contact" placeholder="请输入联系人"></el-input></el-form-item></el-col>
              <el-col :span="12"><el-form-item label="电话"><el-input v-model="form.phone" placeholder="请输入联系电话"></el-input></el-form-item></el-col>
            </el-row>

            <div class="section-title"><span class="bar"></span>样品信息<span class="tip">可新增多个样品，每个样品生成一条检测委托任务，价格按功率区间与检验类型自动计算</span></div>
            <div
              v-for="(sample, index) in samples"
              :key="sample._key"
              class="sample-block"
            >
              <div class="sample-block-head">样品 {{ index + 1 }}</div>
              <a v-if="samples.length > 1" href="javascript:;" class="sample-remove" @click="removeSample(index)">删除样品</a>
              <el-row :gutter="40">
                <el-col :span="12"><el-form-item label="样品名称" required><el-input v-model="sample.sampleName" placeholder="请输入样品名称"></el-input></el-form-item></el-col>
                <el-col :span="12">
                  <el-form-item label="产品分类" required>
                    <el-select v-model="sample.productCategory" placeholder="请选择产品分类" style="width:100%" filterable>
                      <el-option
                        v-for="c in categories"
                        :key="c.uuid || c.code || c.name"
                        :label="c.name"
                        :value="c.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="检验类型" required>
                    <div class="test-type-row">
                      <el-select v-model="sample.testType" class="test-type-select" @change="refreshSamplePrice(index)">
                        <el-option label="性能测试" value="性能测试"></el-option>
                        <el-option label="CMA测试" value="CMA测试"></el-option>
                      </el-select>
                      <span class="test-type-remark">[{{ testTypeRemark(sample.testType) }}]</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="功率(kW)" required>
                    <el-select v-model="sample.feeUuid" placeholder="请选择功率区间" style="width:100%" @change="refreshSamplePrice(index)">
                      <el-option v-for="f in feeList" :key="f.uuid" :label="f.powerRangeLabel" :value="f.uuid"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12"><el-form-item label="样品规格型号"><el-input v-model="sample.model" placeholder="请输入样品规格型号"></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item label="生产日期"><el-date-picker v-model="sample.produceDate" type="date" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker></el-form-item></el-col>
                <el-col :span="12"><el-form-item label="产品数量"><el-input-number v-model="sample.sampleCount" :min="1"></el-input-number></el-form-item></el-col>
                <el-col :span="12"><el-form-item label="备样数量" required><el-input-number v-model="sample.backupCount" :min="0" @change="refreshSamplePrice(index)"></el-input-number></el-form-item></el-col>
                <el-col :span="12">
                  <el-form-item label="送样人" required>
                    <div class="input-with-hint">
                      <el-input v-model="sample.sender" placeholder="请输入送样人"></el-input>
                      <span class="hint-chip">默认当前登录人，可修改</span>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12"><el-form-item label="送样日期"><el-date-picker v-model="sample.sendDate" type="date" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker></el-form-item></el-col>
                <el-col :span="12"><el-form-item label="样品价格"><div class="static-value">¥{{ formatMoney(sample.totalAmount) }}（按收费标准自动计算）</div></el-form-item></el-col>
              </el-row>
            </div>
            <el-button class="add-sample-btn" type="primary" plain icon="el-icon-plus" @click="addSample">新增样品</el-button>

            <div class="price-bar">
              <span>样品数量：<b>{{ totalSampleQty }}</b> 个</span>
              <span>备样合计：<b>{{ totalBackupQty }}</b> 个</span>
              <span class="total">总计价格：<span class="money">¥{{ formatMoney(totalAmount) }}</span></span>
            </div>
            <div class="form-actions">
              <el-button type="primary" class="btn-submit" @click="openOrderConfirm">确认订单</el-button>
              <el-button @click="resetForm">取消</el-button>
            </div>
          </el-form>
        </div>

        <!-- 我的委托单 -->
        <div v-show="activeTab === 'list'" class="tab-panel">
          <el-form :model="orderQuery" class="order-query-form" label-position="top" @submit.native.prevent>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item label="委托单号">
                  <el-input v-model="orderQuery.orderNo" clearable placeholder="请输入委托单号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="样品名称">
                  <el-input v-model="orderQuery.sampleName" clearable placeholder="请输入样品名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="委托单位">
                  <el-input v-model="orderQuery.entrustUnit" clearable placeholder="请输入委托单位"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="检验类型">
                  <el-select v-model="orderQuery.testType" clearable placeholder="全部" style="width:100%">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="性能测试" value="性能测试"></el-option>
                    <el-option label="CMA测试" value="CMA测试"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select v-model="orderQuery.listStatus" clearable placeholder="全部" style="width:100%">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待支付" value="waitPay"></el-option>
                    <el-option label="检测中" value="testing"></el-option>
                    <el-option label="已完成" value="done"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="委托日期">
                  <el-date-picker
                    v-model="orderQuery.dateRange"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="—"
                    start-placeholder="yyyy/mm/dd"
                    end-placeholder="yyyy/mm/dd"
                    style="width:100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="order-query-actions">
                <el-form-item label=" ">
                  <el-button type="primary" class="btn-submit" @click="searchOrders">查询</el-button>
                  <el-button @click="resetOrderQuery">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table :data="orderList" border stripe>
            <el-table-column prop="orderNo" label="委托单号" min-width="140"></el-table-column>
            <el-table-column prop="entrustDate" label="委托日期" width="120"></el-table-column>
            <el-table-column prop="sampleName" label="样品名称" min-width="120"></el-table-column>
            <el-table-column label="产品分类" min-width="140">
              <template slot-scope="{ row }">{{ categoryName(row.productCategory) }}</template>
            </el-table-column>
            <el-table-column prop="model" label="规格型号" min-width="100"><template slot-scope="{ row }">{{ row.model || '—' }}</template></el-table-column>
            <el-table-column prop="testType" label="检验类型" width="100"></el-table-column>
            <el-table-column prop="sampleCount" label="样品数量" width="90"></el-table-column>
            <el-table-column label="送样人" width="100">
              <template slot-scope="{ row }">{{ row.sender || '—' }}</template>
            </el-table-column>
            <el-table-column label="送样日期" width="120">
              <template slot-scope="{ row }">{{ formatDate(row.sendDate) }}</template>
            </el-table-column>
            <el-table-column label="检测费用(元)" width="110"><template slot-scope="{ row }">{{ formatMoney(row.totalAmount) }}</template></el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="{ row }"><el-tag :type="statusTag(row)" size="small">{{ statusText(row) }}</el-tag></template>
            </el-table-column>
            <el-table-column label="任务状态" width="110">
              <template slot-scope="{ row }">
                <el-tag v-if="isPaid(row)" :type="progressTag(row)" size="small">{{ progressText(row) }}</el-tag>
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column label="检验员" width="100">
              <template slot-scope="{ row }">{{ row.inspector || '—' }}</template>
            </el-table-column>
            <el-table-column label="检验完成时间" width="160">
              <template slot-scope="{ row }">{{ formatDate(row.finishDate, true) }}</template>
            </el-table-column>
            <el-table-column prop="reportNo" label="报告编号" min-width="120"><template slot-scope="{ row }">{{ row.reportNo || '—' }}</template></el-table-column>
            <el-table-column label="试验报告" width="90">
              <template slot-scope="{ row }"><a v-if="row.reportUrl" :href="row.reportUrl" target="_blank">附件</a><span v-else>—</span></template>
            </el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
              <template slot-scope="{ row }">
                <el-button v-if="canPay(row)" type="text" @click="resumePay(row)">去支付</el-button>
                <el-button type="text" @click="viewOrder(row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-if="orderTotal > 0" style="margin-top:16px;text-align:right" layout="total, prev, pager, next" :total="orderTotal" :current-page.sync="orderPage" :page-size="10" @current-change="loadOrders"></el-pagination>
        </div>

        <!-- 收费标准 -->
        <div v-show="activeTab === 'fee'" class="tab-panel">
          <div class="section-title"><span class="bar"></span>水泵实验收费标准<span class="tip">金额单位：台次/元</span></div>
          <el-table :data="feeList" border>
            <el-table-column type="index" label="序号" width="70"></el-table-column>
            <el-table-column prop="powerRangeLabel" label="功率（kW）"></el-table-column>
            <el-table-column prop="perfPrice" label="性能实验"></el-table-column>
            <el-table-column prop="cmaPrice" label="CMA测试报告"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 订单确认 -->
    <el-dialog title="订单确认" :visible.sync="orderModalVisible" width="900px" custom-class="order-confirm-dlg" :close-on-click-modal="false">
      <div class="order-meta">
        <div class="m">委托单位<b>{{ form.entrustUnit }}</b></div>
        <div class="m">联系人 / 电话<b>{{ form.contact }} / {{ form.phone || '—' }}</b></div>
        <div class="m">委托日期<b>{{ form.entrustDate }}</b></div>
        <div class="m">检测样品<b>{{ totalBackupQty }} 个（{{ sampleNameSummary }}）</b></div>
      </div>
      <div class="section-title" style="margin-top:0"><span class="bar"></span>检测样品明细<span class="tip">按不同检测样品分别生成订单明细，单价取自收费标准</span></div>
      <el-table :data="confirmRows" border size="small">
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="sampleName" label="样品名称"></el-table-column>
        <el-table-column prop="productCategory" label="产品分类"></el-table-column>
        <el-table-column prop="model" label="规格型号"></el-table-column>
        <el-table-column prop="testType" label="检验类型" width="90"></el-table-column>
        <el-table-column prop="powerRangeLabel" label="功率区间" width="110"></el-table-column>
        <el-table-column prop="sampleCount" label="产品数量" width="80"></el-table-column>
        <el-table-column prop="backupCount" label="备样数量" width="80"></el-table-column>
        <el-table-column label="单价(元)" width="90"><template slot-scope="{ row }">¥ {{ Number(row.unitPrice || 0).toLocaleString() }}</template></el-table-column>
        <el-table-column label="小计(元)" width="100"><template slot-scope="{ row }"><span class="red">¥ {{ formatMoney(row.totalAmount) }}</span></template></el-table-column>
      </el-table>
      <div class="confirm-total">合计备样 {{ totalBackupQty }}　合计 <span class="red">￥{{ formatMoney(totalAmount) }}</span></div>

      <div class="section-title"><span class="bar"></span>支付方式<span class="tip">请选择本次检测费用的支付方式</span></div>
      <div class="pay-methods">
        <div class="pay-card" :class="{ active: payMethod === 'online' }" @click="payMethod = 'online'">
          <div class="pk online">⚡</div>
          <div><div class="pt">在线支付</div><div class="pd">微信 / 支付宝，支付后即时受理</div></div>
          <div class="tick">✓</div>
        </div>
        <div class="pay-card" :class="{ active: payMethod === 'offline' }" @click="payMethod = 'offline'">
          <div class="pk offline">🏦</div>
          <div><div class="pt">线下支付</div><div class="pd">对公转账后上传付款凭证，人工审核</div></div>
          <div class="tick">✓</div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="orderModalVisible = false">返回修改</el-button>
        <el-button type="primary" class="btn-submit" :loading="creating" @click="goPay">去支付</el-button>
      </span>
    </el-dialog>

    <!-- 线下支付上传凭证 -->
    <el-dialog title="线下支付 · 上传付款凭证" :visible.sync="offlineModalVisible" width="720px" :close-on-click-modal="false" @close="cancelOffline">
      <div class="bank-box">
        <div class="bg-t">收款账户信息</div>
        <div class="bank-grid">
          <div class="r"><span>收款户名</span><b>盐湖区水泵检测服务中心</b></div>
          <div class="r"><span>开户银行</span><b>中国建设银行盐湖支行</b></div>
          <div class="r"><span>银行账号</span><b>1405 0110 0987 6543 210</b></div>
          <div class="r"><span>应付金额</span><b class="red">￥{{ formatMoney(batchPayAmount) }}</b></div>
          <div class="r"><span>订单编号</span><b>{{ createdOrderNos }}</b></div>
          <div class="r"><span>转账备注</span><b>请填写订单编号后 6 位</b></div>
        </div>
      </div>
      <div class="section-title" style="margin-top:16px"><span class="bar"></span>上传付款凭证<span class="tip">支持 JPG / PNG / PDF，单个文件不超过 10MB</span></div>
      <el-upload
        class="voucher-upload"
        drag
        action="/service-center/upload/file/single"
        name="file"
        :headers="uploadHeaders"
        :limit="1"
        accept=".jpg,.jpeg,.png,.pdf"
        :before-upload="beforeVoucherUpload"
        :on-success="handleVoucherSuccess"
        :on-error="handleVoucherError"
        :on-remove="() => { offlineForm.payVoucherUrl = '' }"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击上传付款凭证<br><em>请上传银行转账回单、支付截图等有效凭证图片</em></div>
      </el-upload>
      <div class="section-title"><span class="bar"></span>补充信息</div>
      <el-form :model="offlineForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12"><el-form-item label="付款方名称" required><el-input v-model="offlineForm.payerName"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="付款时间"><el-date-picker v-model="offlineForm.payDate" type="date" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="offlineForm.payRemark" placeholder="如需说明请填写（选填）"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="cancelOffline">取 消</el-button>
        <el-button type="primary" class="btn-submit" :loading="voucherSubmitting" @click="submitVoucher">提交凭证，等待审核</el-button>
      </span>
    </el-dialog>

    <!-- 结果 -->
    <el-dialog :visible.sync="resultVisible" width="520px" :show-close="false">
      <div class="pay-result">
        <div class="r-ico">{{ resultIco }}</div>
        <div class="r-t">{{ resultTitle }}</div>
        <div class="r-d" v-html="resultDesc"></div>
      </div>
      <span slot="footer" style="text-align:center;display:block">
        <el-button type="primary" class="btn-submit" @click="finishOrder">查看我的委托单</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="detailVisible"
      width="980px"
      custom-class="order-detail-dlg"
      :close-on-click-modal="false"
    >
      <div slot="title" class="detail-dlg-title">
        <span class="bar"></span>
        <span class="t">委托单详情</span>
        <span v-if="detailOrder" class="status-badge" :class="detailBadgeClass(detailOrder)">{{ detailBadgeText(detailOrder) }}</span>
      </div>
      <div v-if="detailOrder" class="order-detail">
        <div class="detail-meta-card">
          <div class="meta-item"><label>委托单号</label><div class="val">{{ detailOrder.orderNo || '—' }}</div></div>
          <div class="meta-item"><label>委托日期</label><div class="val">{{ formatDate(detailOrder.entrustDate) }}</div></div>
          <div class="meta-item"><label>送样日期</label><div class="val">{{ formatDate(detailOrder.sendDate) }}</div></div>
          <div class="meta-item"><label>委托单位</label><div class="val">{{ detailOrder.entrustUnit || '—' }}</div></div>
          <div class="meta-item"><label>联系人 / 电话</label><div class="val">{{ detailContactPhone }}</div></div>
          <div class="meta-item"><label>送样人</label><div class="val">{{ detailOrder.sender || '—' }}</div></div>
          <div class="meta-item span-2"><label>单位地址</label><div class="val">{{ detailOrder.unitAddress || '—' }}</div></div>
        </div>

        <div class="section-title detail-sec"><span class="bar"></span>样品明细</div>
        <el-table :data="detailSampleRows" border size="small" class="detail-sample-table">
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column prop="sampleName" label="样品名称" min-width="120"></el-table-column>
          <el-table-column label="产品分类" min-width="110">
            <template slot-scope="{ row }">{{ categoryName(row.productCategory) }}</template>
          </el-table-column>
          <el-table-column prop="model" label="规格型号" min-width="100">
            <template slot-scope="{ row }">{{ row.model || '—' }}</template>
          </el-table-column>
          <el-table-column prop="testType" label="检验类型" width="100"></el-table-column>
          <el-table-column label="功率区间" width="110">
            <template slot-scope="{ row }">{{ row.powerRangeLabel || '—' }}</template>
          </el-table-column>
          <el-table-column prop="sampleCount" label="产品数量" width="90"></el-table-column>
          <el-table-column prop="backupCount" label="备样数量" width="90"></el-table-column>
          <el-table-column label="单价(元)" width="90">
            <template slot-scope="{ row }">¥ {{ Number(row.unitPrice || 0).toLocaleString() }}</template>
          </el-table-column>
          <el-table-column label="小计(元)" width="110">
            <template slot-scope="{ row }"><span class="red">¥ {{ formatMoney(row.totalAmount) }}</span></template>
          </el-table-column>
        </el-table>
        <div class="detail-sample-sum">
          <span>样品合计 {{ detailSampleRows.length }} 个 / 产品数量 {{ detailOrder.sampleCount || 0 }} 台 / 备样 {{ detailOrder.backupCount || 0 }} 台</span>
          <span class="sum-fee">费用合计：<b>¥ {{ formatMoney(detailOrder.totalAmount) }}</b></span>
        </div>

        <div class="section-title detail-sec"><span class="bar"></span>支付与受理信息</div>
        <div class="detail-meta-card pay-card-meta">
          <div class="meta-item"><label>支付方式</label><div class="val">{{ payChannelLabel(detailOrder) }}</div></div>
          <div class="meta-item"><label>支付时间</label><div class="val">{{ formatDate(detailOrder.payApplyTime || detailOrder.payDate, !!detailOrder.payApplyTime) }}</div></div>
          <div class="meta-item"><label>交易单号</label><div class="val">{{ detailOrder.externalOrderNo || '—' }}</div></div>
          <div class="meta-item span-2"><label>备注</label><div class="val">{{ detailOrder.payRemark || '—' }}</div></div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" class="btn-submit" @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getInspectionFeeList,
  saveInspectionOrder,
  getInspectionOrderQuery,
  getInspectionOrderDetail,
  submitInspectionOfflinePay,
  gotoInspectionOnlinePay,
  getApprovedEnterpriseList,
  getEnterpriseCredentials,
  getDictionaryItem
} from '@/utils/interface.js';

export default {
  name: 'detectionEntrust',
  data() {
    return {
      activeTab: 'apply',
      feeList: [],
      enterpriseList: [],
      categories: [],
      form: this.emptyForm(),
      samples: [this.emptySample()],
      orderQuery: this.emptyOrderQuery(),
      orderList: [],
      orderPage: 1,
      orderTotal: 0,
      orderModalVisible: false,
      payMethod: 'online',
      creating: false,
      createdOrder: null,
      createdOrders: [],
      offlineModalVisible: false,
      offlineForm: { payerName: '', payDate: '', payRemark: '', payVoucherUrl: '', payMethod: '线下转账' },
      voucherSubmitting: false,
      resultVisible: false,
      resultIco: '✓',
      resultTitle: '',
      resultDesc: '',
      detailVisible: false,
      detailOrder: null
    };
  },
  computed: {
    user() {
      return this.$store.state.isUsermessage || {};
    },
    isEnterpriseAccount() {
      const id = this.user.identity;
      return id === 'ENTERPRISE' || id === 'STAFF';
    },
    defaultSender() {
      const u = this.user;
      return this.form.contact || u.nickName || u.userName || u.name || '';
    },
    confirmRows() {
      return this.samples.map(s => {
        const fee = this.feeList.find(f => f.uuid === s.feeUuid);
        return {
          ...s,
          powerRangeLabel: fee ? fee.powerRangeLabel : '—',
          model: s.model || '—'
        };
      });
    },
    totalSampleQty() {
      return this.samples.reduce((sum, s) => sum + Math.max(s.sampleCount || 1, 1), 0);
    },
    totalBackupQty() {
      return this.samples.reduce((sum, s) => sum + (Number(s.backupCount) || 0), 0);
    },
    totalAmount() {
      return this.samples.reduce((sum, s) => sum + Number(s.totalAmount || 0), 0);
    },
    sampleNameSummary() {
      return this.samples.map(s => s.sampleName || '未命名').join('、');
    },
    batchPayAmount() {
      if (this.createdOrders && this.createdOrders.length) {
        return this.createdOrders.reduce((sum, o) => sum + Number(o.totalAmount || 0), 0);
      }
      return (this.createdOrder && this.createdOrder.totalAmount) || this.totalAmount;
    },
    createdOrderNos() {
      if (this.createdOrders && this.createdOrders.length) {
        return this.createdOrders.map(o => o.orderNo).filter(Boolean).join('、');
      }
      return (this.createdOrder && this.createdOrder.orderNo) || '—';
    },
    uploadHeaders() {
      const token = this.$cookies && this.$cookies.get('api_access_token');
      const headers = {};
      if (token) headers.Authorization = 'Bearer ' + token;
      const u = this.user || {};
      if (u.uuid) {
        headers.user_uuid = u.uuid;
        headers['user-uuid'] = u.uuid;
      }
      return headers;
    },
    detailContactPhone() {
      const o = this.detailOrder;
      if (!o) return '—';
      const c = o.contact || '';
      const p = o.phone || '';
      if (c && p) return `${c} / ${p}`;
      return c || p || '—';
    },
    detailSampleRows() {
      return this.detailOrder ? [this.detailOrder] : [];
    }
  },
  mounted() {
    Promise.all([this.loadFee(), this.loadEnterprises(), this.loadCategories()]).then(() => {
      this.prefillUser();
      this.initDefaultFee();
      this.applyTabFromRoute();
    });
  },
  watch: {
    '$route.query.tab'() {
      this.applyTabFromRoute();
    }
  },
  methods: {
    applyTabFromRoute() {
      const tab = (this.$route.query && this.$route.query.tab) || '';
      if (tab === 'list' || tab === 'fee' || tab === 'apply') {
        this.switchTab(tab);
      }
    },
    emptyForm() {
      return {
        entrustUnit: '',
        unitAddress: '',
        entrustDate: this.today(),
        contact: '',
        phone: '',
        enterpriseUuid: '',
        payChannel: 'online'
      };
    },
    emptyOrderQuery() {
      return {
        orderNo: '',
        sampleName: '',
        entrustUnit: '',
        testType: '',
        listStatus: '',
        dateRange: []
      };
    },
    emptySample() {
      return {
        _key: `s_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        sampleName: '',
        productCategory: '',
        testType: '性能测试',
        feeUuid: '',
        model: '',
        produceDate: '',
        sampleCount: 1,
        backupCount: 1,
        sender: '',
        sendDate: this.today(),
        unitPrice: 0,
        totalAmount: 0
      };
    },
    today() {
      const d = new Date();
      return `${d.getFullYear()}-${`${d.getMonth() + 1}`.padStart(2, '0')}-${`${d.getDate()}`.padStart(2, '0')}`;
    },
    initDefaultFee() {
      if (!this.feeList.length) return;
      this.samples.forEach((s, i) => {
        if (!s.feeUuid) {
          this.$set(this.samples[i], 'feeUuid', this.feeList[0].uuid);
        }
        this.refreshSamplePrice(i);
      });
    },
    addSample() {
      const sample = this.emptySample();
      sample.sender = this.defaultSender;
      if (this.feeList.length) sample.feeUuid = this.feeList[0].uuid;
      this.samples.push(sample);
      this.refreshSamplePrice(this.samples.length - 1);
    },
    removeSample(index) {
      if (this.samples.length <= 1) {
        this.$message.error('至少保留一个样品');
        return;
      }
      this.samples.splice(index, 1);
    },
    testTypeRemark(type) {
      if (type === 'CMA测试') {
        return '开展第三方检验检测，出具加盖 CMA 标识的正式检验检测报告。';
      }
      return '泵产品性能测试，出具试验数据，不对样品试验结果作出合格与否判定；';
    },
    refreshSamplePrice(index) {
      const sample = this.samples[index];
      if (!sample) return;
      const fee = this.feeList.find(f => f.uuid === sample.feeUuid);
      if (!fee) {
        sample.unitPrice = 0;
        sample.totalAmount = 0;
        return;
      }
      const unit = sample.testType === 'CMA测试' ? Number(fee.cmaPrice) : Number(fee.perfPrice);
      const qty = Math.max(Number(sample.backupCount) || 0, 0);
      sample.unitPrice = unit;
      sample.totalAmount = unit * qty;
    },
    loadEnterprises() {
      return getApprovedEnterpriseList({ status: 'APPROVE', current: 1, pageSize: 5000 }).then(res => {
        const list = (res && res.data) || (res && res.list) || [];
        this.enterpriseList = Array.isArray(list) ? list : [];
      }).catch(() => { this.enterpriseList = []; });
    },
    loadCategories() {
      return getDictionaryItem({ groupCode: 'CHECK_TASK_PRODUCT_TYPE' }).then(res => {
        const list = Array.isArray(res) ? res : (res && res.data) || [];
        this.categories = Array.isArray(list) ? list : [];
      }).catch(() => { this.categories = []; });
    },
    categoryName(val) {
      if (!val) return '—';
      const hit = (this.categories || []).find(c =>
        c.name === val || c.value === val || c.code === val || c.uuid === val
      );
      return (hit && hit.name) || val;
    },
    applyEnterpriseInfo(ent) {
      if (!ent) return;
      this.form.enterpriseUuid = ent.uuid || '';
      this.form.entrustUnit = ent.name || '';
      this.form.unitAddress = ent.address || this.form.unitAddress || '';
      this.form.contact = ent.contact || this.form.contact || '';
      this.form.phone = ent.contactTel || ent.tel || this.form.phone || '';
      this.samples.forEach(s => {
        if (!s.sender) s.sender = this.form.contact;
      });
    },
    onEntrustUnitChange(uuid) {
      if (!uuid) {
        this.form.entrustUnit = '';
        if (!this.isEnterpriseAccount) {
          this.form.unitAddress = '';
          this.form.contact = '';
          this.form.phone = '';
        }
        return;
      }
      const ent = this.enterpriseList.find(e => e.uuid === uuid);
      if (ent) this.applyEnterpriseInfo(ent);
    },
    goEnterpriseAuth() {
      this.$router.push('/userCenter/11');
    },
    currentUserHeaders() {
      const u = this.user || {};
      const headers = {};
      if (u.uuid) {
        headers.user_uuid = u.uuid;
        headers['user-uuid'] = u.uuid;
      }
      return headers;
    },
    prefillUser() {
      if (!this.isEnterpriseAccount) {
        this.form.entrustUnit = '';
        this.form.enterpriseUuid = '';
        this.form.unitAddress = '';
        this.form.contact = '';
        this.form.phone = '';
        const u = this.user;
        const sender = u.nickName || u.userName || u.name || '';
        this.samples.forEach(s => { s.sender = sender; });
        return;
      }
      getEnterpriseCredentials().then(res => {
        const data = (res && res.data) || res || {};
        if (!data || !data.name) return;
        this.applyEnterpriseInfo(data);
        const matched = this.enterpriseList.find(e => e.uuid === data.uuid || e.name === data.name);
        if (matched) this.form.enterpriseUuid = matched.uuid;
      }).catch(() => {
        const u = this.user;
        this.form.entrustUnit = u.name || '';
        this.form.contact = u.nickName || u.userName || u.name || '';
        this.form.phone = u.tel || u.phone || '';
        this.samples.forEach(s => { s.sender = this.form.contact; });
      });
    },
    loadFee() {
      return getInspectionFeeList().then(res => {
        this.feeList = Array.isArray(res) ? res : (res && res.data) || [];
      }).catch(() => { this.feeList = []; });
    },
    resetForm() {
      this.form = this.emptyForm();
      this.samples = [this.emptySample()];
      this.createdOrders = [];
      this.prefillUser();
      this.initDefaultFee();
    },
    openOrderConfirm() {
      if (!this.$store.state.isLogin) {
        this.$message.warning('您需要先登陆哦！');
        this.$router.push({ name: 'login' });
        return;
      }
      if (!this.form.enterpriseUuid && !this.form.entrustUnit) return this.$message.error('请选择委托单位');
      if (this.form.enterpriseUuid && !this.form.entrustUnit) {
        const ent = this.enterpriseList.find(e => e.uuid === this.form.enterpriseUuid);
        if (ent) this.form.entrustUnit = ent.name;
      }
      if (!this.form.entrustUnit) return this.$message.error('请选择委托单位');
      if (!this.form.entrustDate) return this.$message.error('请选择委托日期');
      if (!this.form.contact) return this.$message.error('请填写联系人');
      for (let i = 0; i < this.samples.length; i++) {
        const s = this.samples[i];
        const n = i + 1;
        if (!s.sampleName) return this.$message.error(`请填写样品${n}名称`);
        if (!s.productCategory) return this.$message.error(`请选择样品${n}产品分类`);
        if (!s.feeUuid) return this.$message.error(`请选择样品${n}功率区间`);
        if (!s.sender) return this.$message.error(`请填写样品${n}送样人`);
        this.refreshSamplePrice(i);
      }
      this.payMethod = 'online';
      this.orderModalVisible = true;
    },
    goPay() {
      if (!this.$store.state.isLogin) {
        this.$message.warning('您需要先登陆哦！');
        this.$router.push({ name: 'login' });
        return;
      }
      const headers = this.currentUserHeaders();
      if (!headers.user_uuid) {
        this.$message.warning('您需要先登陆哦！');
        this.$router.push({ name: 'login' });
        return;
      }
      this.creating = true;
      const tasks = this.samples.map(s => {
        const { _key, ...sampleData } = s;
        return saveInspectionOrder({
          ...this.form,
          ...sampleData,
          payChannel: this.payMethod
        }, headers);
      });
      Promise.all(tasks).then(results => {
        this.creating = false;
        const orders = [];
        for (let i = 0; i < results.length; i++) {
          const res = results[i];
          if (!res || res.success === false) {
            this.$message.error((res && res.message) || `样品${i + 1}生成委托单失败`);
            return;
          }
          orders.push(res.data || res);
        }
        this.createdOrders = orders;
        this.createdOrder = orders[0];
        this.orderModalVisible = false;
        if (this.payMethod === 'online') {
          this.jumpOnlinePay();
        } else {
          this.openOfflinePay();
        }
      }).catch(() => {
        this.creating = false;
        this.$message.error('生成委托单失败');
      });
    },
    jumpOnlinePay() {
      const orders = (this.createdOrders && this.createdOrders.length) ? this.createdOrders : (this.createdOrder ? [this.createdOrder] : []);
      if (!orders.length || !orders[0].uuid) {
        this.$message.error('订单信息异常');
        return;
      }
      const headers = this.currentUserHeaders();
      const nos = orders.map(o => o.orderNo).filter(Boolean).join('、');
      const uuids = orders.map(o => o.uuid).filter(Boolean);
      // 多笔委托单一并传 uuids，后端合计金额后一次易宝下单
      gotoInspectionOnlinePay({ uuids, uuid: uuids[0], orderUuid: uuids[0] }, headers).then(res => {
        if (!res || res.success === false) {
          this.$message.error((res && res.message) || '发起支付失败');
          return;
        }
        const payParam = (res && res.data) || res || {};
        const payLink = payParam.payUrl || payParam.cashierUrl;
        if (!payLink) {
          this.$message.error('未返回支付地址');
          return;
        }
        window.open(payLink, '_blank');
        const amountText = payParam.totalAmount != null
          ? payParam.totalAmount
          : this.formatMoney(this.batchPayAmount);
        this.showResult('⚡', '已跳转支付',
          `已生成 ${orders.length} 个委托单：${nos}<br>应付合计：￥${amountText}<br>请在新打开的易宝收银台完成在线支付；支付成功后可在「我的委托单」查看进度`);
      }).catch(() => {
        this.$message.error('发起在线支付失败');
      });
    },
    openOfflinePay() {
      this.offlineForm = {
        payerName: this.form.entrustUnit,
        payDate: this.today(),
        payRemark: '',
        payVoucherUrl: '',
        payMethod: '线下转账'
      };
      this.offlineModalVisible = true;
    },
    beforeVoucherUpload(file) {
      const okType = /\.(jpe?g|png|pdf)$/i.test(file.name);
      if (!okType) {
        this.$message.error('仅支持 JPG / PNG / PDF');
        return false;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('文件超过 10MB，请压缩后重新上传');
        return false;
      }
      return true;
    },
    handleVoucherSuccess(res) {
      const data = (res && res.data) || res || {};
      const url = data.url || data.fileUrl || (res && res.url) || '';
      this.offlineForm.payVoucherUrl = url;
      if (!url) this.$message.error('上传失败，请重试');
      else this.$message.success('凭证上传成功');
    },
    handleVoucherError() {
      this.$message.error('凭证上传失败，请稍后重试');
    },
    submitVoucher() {
      if (!this.offlineForm.payerName) return this.$message.error('请填写付款方名称');
      const orders = (this.createdOrders && this.createdOrders.length) ? this.createdOrders : (this.createdOrder ? [this.createdOrder] : []);
      if (!orders.length) return this.$message.error('订单信息异常');
      this.voucherSubmitting = true;
      const headers = this.currentUserHeaders();
      Promise.all(orders.map(o => submitInspectionOfflinePay({
        uuid: o.uuid,
        orderUuid: o.uuid,
        ...this.offlineForm
      }, headers))).then(results => {
        this.voucherSubmitting = false;
        const failed = results.find(res => res && res.success === false);
        if (failed) {
          this.$message.error((failed && failed.message) || '提交失败');
          return;
        }
        this.offlineModalVisible = false;
        this.showResult('⏳', '付款凭证已提交',
          `订单编号：${this.createdOrderNos}<br>付款金额：￥${this.formatMoney(this.batchPayAmount)}（线下转账）<br>审核结果将在 1 个工作日内通知，请留意站内消息`);
      }).catch(() => {
        this.voucherSubmitting = false;
        this.$message.error('提交失败');
      });
    },
    cancelOffline() {
      this.offlineModalVisible = false;
    },
    showResult(ico, title, desc) {
      this.resultIco = ico;
      this.resultTitle = title;
      this.resultDesc = desc;
      this.resultVisible = true;
    },
    finishOrder() {
      this.resultVisible = false;
      this.createdOrder = null;
      this.createdOrders = [];
      this.resetForm();
      this.switchTab('list');
    },
    resumePay(row) {
      this.createdOrder = row;
      this.createdOrders = [row];
      this.$confirm('请选择支付方式', '去支付', {
        distinguishCancelAndClose: true,
        confirmButtonText: '在线支付',
        cancelButtonText: '线下支付'
      }).then(() => {
        this.payMethod = 'online';
        this.jumpOnlinePay();
      }).catch(action => {
        if (action === 'cancel') {
          this.payMethod = 'offline';
          this.openOfflinePay();
        }
      });
    },
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'list') this.loadOrders();
      else if (tab === 'fee') this.loadFee();
    },
    searchOrders() {
      this.orderPage = 1;
      this.loadOrders();
    },
    resetOrderQuery() {
      this.orderQuery = this.emptyOrderQuery();
      this.orderPage = 1;
      this.loadOrders();
    },
    loadOrders() {
      const q = this.orderQuery || {};
      const params = {
        current: this.orderPage,
        pageSize: 10
      };
      if (q.orderNo) params.orderNo = q.orderNo;
      if (q.sampleName) params.sampleName = q.sampleName;
      if (q.entrustUnit) params.entrustUnit = q.entrustUnit;
      if (q.testType) params.testType = q.testType;
      if (q.listStatus) params.listStatus = q.listStatus;
      if (q.dateRange && q.dateRange.length === 2) {
        params.entrustDateStart = q.dateRange[0];
        params.entrustDateEnd = q.dateRange[1];
      }
      getInspectionOrderQuery(params).then(res => {
        this.orderList = (res && res.list) || [];
        this.orderTotal = (res && res.total) || 0;
      }).catch(() => { this.orderList = []; this.orderTotal = 0; });
    },
    isPaid(row) {
      return row && (row.status === 1 || row.status === 2);
    },
    canPay(row) {
      // 待支付或已驳回可去支付；待审核不可
      return row && row.status === 0 && row.auditStatus !== 0;
    },
    statusText(row) {
      if (!row) return '-';
      if (row.auditStatus === 0) return '待审核';
      if (row.auditStatus === 2 && row.status === 0) return '驳回';
      if (row.status === 0) return '待支付';
      if (row.status === 1 || row.status === 2) return '已支付';
      return '-';
    },
    statusTag(row) {
      if (!row) return 'info';
      if (row.auditStatus === 0) return 'warning';
      if (row.auditStatus === 2 && row.status === 0) return 'danger';
      if (row.status === 0) return 'warning';
      return 'success';
    },
    progressText(row) {
      if (!row || !this.isPaid(row)) return '—';
      return { 0: '待检测', 1: '样品检测中', 2: '报告完成' }[row.progress] || '—';
    },
    progressTag(row) {
      if (!row || !this.isPaid(row)) return 'info';
      return { 0: 'info', 1: '', 2: 'success' }[row.progress] || 'info';
    },
    detailBadgeText(row) {
      if (!row) return '';
      if (row.auditStatus === 0) return '待审核';
      if (row.auditStatus === 2 && row.status === 0) return '驳回';
      if (row.status === 0) return '待支付';
      if (row.progress === 2 || row.status === 2) return '已完成';
      if (row.progress === 0) return '待检测';
      return '检测中';
    },
    detailBadgeClass(row) {
      if (!row) return '';
      if (row.auditStatus === 0) return 'is-warning';
      if (row.auditStatus === 2 && row.status === 0) return 'is-danger';
      if (row.status === 0) return 'is-warning';
      if (row.progress === 2 || row.status === 2) return 'is-success';
      return 'is-info';
    },
    payChannelLabel(row) {
      if (!row) return '—';
      if (row.payChannel === 'offline') return '线下支付';
      if (row.payChannel === 'online') {
        return row.payWay ? `在线支付 (${row.payWay})` : '在线支付';
      }
      return '—';
    },
    formatMoney(v) {
      return Number(v || 0).toFixed(2);
    },
    formatDate(v, withTime) {
      if (!v) return '—';
      const s = String(v);
      if (withTime) return s.replace('T', ' ').slice(0, 19);
      return s.slice(0, 10);
    },
    viewOrder(row) {
      getInspectionOrderDetail(row.uuid).then(res => {
        const order = (res && res.data) || res || {};
        if (!order.powerRangeLabel && order.feeUuid && this.feeList.length) {
          const fee = this.feeList.find(f => f.uuid === order.feeUuid);
          if (fee) order.powerRangeLabel = fee.powerRangeLabel;
        } else if (!order.powerRangeLabel && (order.powerLo != null || order.powerHi != null)) {
          const lo = order.powerLo != null ? order.powerLo : '';
          const hi = order.powerHi != null ? order.powerHi : '';
          order.powerRangeLabel = lo !== '' || hi !== '' ? `${lo}~${hi}kW` : '';
        }
        this.detailOrder = order;
        this.detailVisible = true;
      }).catch(() => this.$message.error('获取详情失败'));
    }
  }
};
</script>

<style lang="less" scoped>
.detection-entrust {
  --teal-grad: linear-gradient(90deg, #3AC7B5 0%, #1E9C8E 100%);
  background: #F0F4F8;
  padding-bottom: 40px;
}
.hero {
  height: 230px;
  background: linear-gradient(180deg, rgba(30,120,210,0.85) 0%, rgba(46,150,220,0.78) 100%), linear-gradient(135deg, #4A90D9 0%, #2E6FB7 100%);
  .hero-inner { text-align: center; color: #fff; padding-top: 62px;
    h2 { font-size: 36px; font-weight: 700; letter-spacing: 6px; margin-bottom: 18px; }
    .subtitle { font-size: 16px; letter-spacing: 2px; opacity: .95; }
  }
}
.main-wrap { max-width: 1200px; margin: -70px auto 60px; padding: 0 20px; position: relative; z-index: 10; }
.card {
  background: #fff; border-radius: 12px; box-shadow: 0 6px 30px rgba(21, 80, 145, 0.12); padding: 0 48px 48px; overflow: hidden;
}
.card-head {
  display: flex; align-items: center; justify-content: space-between; margin: 0 -48px 30px;
  background: linear-gradient(90deg, #F4FBFA 0%, #F2F8FD 100%); border-bottom: 1px solid #E8F0F4;
  .head-title {
    display: flex; align-items: center; gap: 10px; padding: 0 32px; font-size: 16px; font-weight: 700; border-right: 1px solid #E8F0F4; align-self: stretch;
    .bar { width: 4px; height: 16px; border-radius: 2px; background: var(--teal-grad); }
    .en { display: block; font-size: 10px; font-weight: 400; color: #999; letter-spacing: 1px; }
  }
  .tabs { display: flex; flex-wrap: wrap; gap: 10px; padding: 16px 24px; margin-left: auto; }
  .tab {
    padding: 9px 22px; border-radius: 20px; font-size: 14px; color: #666; cursor: pointer;
    &.active { background: var(--teal-grad); color: #fff; font-weight: 600; box-shadow: 0 4px 12px rgba(30,156,142,0.35); }
  }
}
.section-title {
  display: flex; align-items: center; gap: 10px; font-size: 16px; font-weight: 700; margin: 28px 0 18px; padding-bottom: 10px; border-bottom: 1px solid #EEF1F4;
  .bar { width: 4px; height: 16px; border-radius: 2px; background: var(--teal-grad); }
  .tip { font-size: 12px; color: #999; font-weight: 400; margin-left: 8px; }
}
.auth-hint {
  margin-top: 6px; font-size: 11px; color: #E74C3C; line-height: 1.4;
  a { color: #E74C3C; margin-left: 2px; }
  a:hover { text-decoration: underline; }
}
.sample-block {
  position: relative; border: 1px solid #E8F0F4; border-radius: 8px; padding: 28px 16px 8px; margin-bottom: 16px; background: #FAFCFC;
  .sample-block-head {
    position: absolute; top: -12px; left: 20px; background: var(--teal-grad); color: #fff; font-size: 12px; padding: 3px 14px; border-radius: 12px; font-weight: 600;
  }
  .sample-remove {
    position: absolute; top: 10px; right: 16px; color: #E74C3C; font-size: 13px;
  }
}
.add-sample-btn {
  margin-bottom: 16px; color: #1E9C8E !important; border-color: #9AD9D0 !important; background: #F4FBFA !important;
}
.input-with-hint {
  display: flex; align-items: center; gap: 8px; width: 100%;
  .el-input { flex: 1; }
  .hint-chip { flex-shrink: 0; font-size: 12px; color: #999; white-space: nowrap; }
}
.test-type-row {
  display: flex; align-items: center; gap: 12px; width: 100%;
  .test-type-select { width: 200px; flex-shrink: 0; }
  .test-type-remark {
    flex: 1; font-size: 12px; color: #999; line-height: 1.5;
  }
}
.static-value { color: #0B7F72; font-weight: 600; }
.price-bar {
  display: flex; align-items: center; gap: 28px; padding: 16px 20px; background: #F4FBFA; border-radius: 8px; margin-bottom: 24px;
  .total { margin-left: auto; }
  .money { color: #E74C3C; font-size: 20px; font-weight: 700; }
}
.form-actions { text-align: center; }
.btn-submit { background: linear-gradient(90deg, #3AC7B5 0%, #1E9C8E 100%) !important; border: none !important; }
.stat-row {
  display: flex; gap: 16px; margin-bottom: 20px;
  .stat-card { flex: 1; background: #F7FAFA; border-radius: 8px; padding: 16px; text-align: center;
    .val { display: block; font-size: 28px; font-weight: 700; color: #0B7F72; }
    .name { font-size: 13px; color: #999; }
  }
}
.order-query-form {
  margin-bottom: 8px;
  padding: 8px 4px 0;
  background: #F7FAFC;
  border-radius: 8px;
  /deep/ .el-form-item { margin-bottom: 12px; }
  /deep/ .el-form-item__label {
    padding: 0 0 6px;
    line-height: 1.2;
    color: #606266;
    font-size: 13px;
  }
  .order-query-actions {
    /deep/ .el-form-item__label { visibility: hidden; }
  }
}
.order-meta {
  display: grid; grid-template-columns: 1fr 1fr; gap: 12px 24px; background: #F7F9FA; border-radius: 8px; padding: 16px 20px; margin-bottom: 16px;
  .m { font-size: 13px; color: #999; b { display: block; color: #333; margin-top: 4px; font-size: 14px; } }
}
.confirm-total { text-align: right; margin: 10px 0 8px; font-size: 14px; }
.red { color: #E74C3C; font-weight: 700; }
.pay-methods { display: flex; gap: 16px; }
.pay-card {
  flex: 1; display: flex; align-items: center; gap: 12px; padding: 16px; border: 1px solid #E5E7EB; border-radius: 10px; cursor: pointer; position: relative;
  &.active { border-color: #1E9C8E; background: #F2FBFA; .tick { opacity: 1; background: #1E9C8E; color: #fff; } }
  .pk { width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 20px;
    &.online { background: #E8F8F0; } &.offline { background: #E8F3FF; }
  }
  .pt { font-weight: 700; margin-bottom: 4px; }
  .pd { font-size: 12px; color: #999; }
  .tick {
    position: absolute; right: 12px; top: 12px; width: 22px; height: 22px; border-radius: 50%; border: 1px solid #DCDFE6;
    display: flex; align-items: center; justify-content: center; font-size: 12px; opacity: .35;
  }
}
.bank-box {
  background: #F4FBFA; border: 1px solid #D9F2EE; border-radius: 8px; padding: 16px 20px;
  .bg-t { font-weight: 700; margin-bottom: 12px; color: #0B7F72; }
  .bank-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 24px; }
  .r { font-size: 13px; span { color: #999; margin-right: 8px; } b { color: #333; } }
}
.voucher-upload { width: 100%; /deep/ .el-upload, /deep/ .el-upload-dragger { width: 100%; } }
.pay-result { text-align: center; padding: 20px 10px;
  .r-ico { font-size: 48px; margin-bottom: 12px; }
  .r-t { font-size: 20px; font-weight: 700; margin-bottom: 12px; }
  .r-d { color: #666; line-height: 1.8; font-size: 14px; }
}
.order-detail {
  .detail-meta-card {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 14px 28px;
    background: #F5F7FA;
    border-radius: 8px;
    padding: 18px 22px;
  }
  .meta-item {
    label {
      display: block;
      font-size: 12px;
      color: #909399;
      margin-bottom: 6px;
      line-height: 1;
    }
    .val {
      font-size: 14px;
      color: #303133;
      line-height: 1.5;
      word-break: break-all;
      a { color: #1E9C8E; }
    }
    &.span-2 { grid-column: span 2; }
    &.span-3 { grid-column: 1 / -1; }
  }
  .detail-sec {
    margin-top: 22px;
    margin-bottom: 12px;
    border-bottom: none;
    padding-bottom: 0;
  }
  .detail-sample-sum {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0;
    padding: 12px 16px;
    background: #EEF7FF;
    border: 1px solid #E4E7ED;
    border-top: none;
    border-radius: 0 0 4px 4px;
    font-size: 13px;
    color: #606266;
    .sum-fee {
      b { color: #E74C3C; font-size: 18px; font-weight: 700; margin-left: 4px; }
    }
  }
  .pay-card-meta { margin-top: 0; }
}
</style>

<style lang="less">
.order-detail-dlg {
  .el-dialog__header {
    padding: 18px 24px 12px;
    border-bottom: 1px solid #EEF1F4;
  }
  .el-dialog__body { padding: 18px 24px 10px; }
  .el-dialog__footer { padding: 12px 24px 20px; }
  .detail-dlg-title {
    display: flex;
    align-items: center;
    gap: 10px;
    .bar {
      width: 4px;
      height: 16px;
      border-radius: 2px;
      background: linear-gradient(90deg, #3AC7B5 0%, #1E9C8E 100%);
    }
    .t { font-size: 16px; font-weight: 700; color: #303133; }
    .status-badge {
      display: inline-block;
      margin-left: 4px;
      padding: 2px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      &.is-info { background: #ECF5FF; color: #409EFF; }
      &.is-warning { background: #FDF6EC; color: #E6A23C; }
      &.is-success { background: #F0F9EB; color: #67C23A; }
      &.is-danger { background: #FEF0F0; color: #F56C6C; }
    }
  }
  .detail-sample-table {
    .el-table__header th { background: #FAFAFA; color: #606266; font-weight: 600; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detectionEntrust/index.vue